import { render, staticRenderFns } from "./HospitalRoomIcon.vue?vue&type=template&id=053176ba"
import script from "./HospitalRoomIcon.vue?vue&type=script&lang=js"
export * from "./HospitalRoomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports